import {useMemo} from 'react';
import {MaxDraftAgents, MaxPublishedAgents} from '../../shared/agent';
import {useCustomer} from '../../hooks/api/metadata';
import _ from 'lodash';

export function useAgentLimits() {
  const customer = useCustomer();

  return useMemo(() => {
    const agents = customer.agents ?? [];
    const [publishedAgents, draftAgents] = _.partition(
      agents,
      (agent) => agent.status === 'published'
    );

    const exceededPublishedLimit = publishedAgents.length >= MaxPublishedAgents;
    const exceededDraftLimit = draftAgents.length >= MaxDraftAgents;

    return {
      limitExceeded: exceededPublishedLimit || exceededDraftLimit,
      limitMessage: exceededPublishedLimit
        ? `You have reached the maximum number of ${MaxPublishedAgents} published agents.`
        : exceededDraftLimit
          ? `You have reached the maximum number of ${MaxDraftAgents} draft agents.`
          : undefined,
    };
  }, [customer.agents]);
}
